import { APP_CONFIG } from 'src/app/helper/Appcode/app-config.service';
import { userAccount } from 'src/app/models/users';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectUser, UserState } from 'src/app/reducers/reducer/userredinfo.reducer';
import { LoaderuiService } from '../Services/loaderui.service';
import { finalize, take } from 'rxjs/operators';
import { SharingDataAppServiceService } from '../Services/sharing-data-app-service.service';
import { UserAuthedDTO } from 'src/app/models/DTO/UserAuthedDTO';


@Injectable()
export class Httpconinter implements HttpInterceptor {

  tuser: any;
  ThisModel: userAccount;
  modified:HttpRequest<any>;
  UserMetaData: UserAuthedDTO;

  constructor(private store: Store<UserState>,
    private SDA: SharingDataAppServiceService,
              public loaderService: LoaderuiService) {
    this.SDA.UserMeta$.subscribe(usermeta => {
      this.UserMetaData = usermeta as UserAuthedDTO;
    });
  }
  intercept(httpRequest: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.loaderService.show();

    if (this.UserMetaData != null) {
      if (!httpRequest.headers.has('Content-Type')) {
        const hh = new HttpHeaders({
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + JSON.stringify(this.UserMetaData.Utoken),
          tenantid: APP_CONFIG.TenantId.toString(),
          userId: this.UserMetaData.UId.toString(),
          aid: this.getaid().toString()
        });
        this.modified = httpRequest.clone({ headers: hh });
      }
      else {
        const hh = new HttpHeaders({
          Accept: 'application/json',
          Authorization: 'Bearer ' + JSON.stringify(this.UserMetaData.Utoken),
          tenantid: APP_CONFIG.TenantId.toString(),
          userId: this.UserMetaData.UId.toString(),
          aid: this.getaid().toString()
        });
        this.modified = httpRequest.clone({ headers: hh });
      }

    }
    else  {
      const hh = new HttpHeaders({
        Accept: 'application/json',
        'Content-Type': 'application/json',
        tenantid: APP_CONFIG.TenantId || '',
        userId: '0',
        aid: this.getaid().toString()
      });
      this.modified = httpRequest.clone({ headers: hh });
    }


    return next.handle(this.modified).pipe(
      finalize(() => this.loaderService.hide())

    );

  }
  getaid(){
    if(this.UserMetaData)
    return this.UserMetaData.ORG_AccountId
    else return 0;
  }
}
